import { render, staticRenderFns } from "./asin.vue?vue&type=template&id=fd2fc2fa&scoped=true"
import script from "./asin.vue?vue&type=script&lang=js"
export * from "./asin.vue?vue&type=script&lang=js"
import style0 from "./asin.vue?vue&type=style&index=0&id=fd2fc2fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2fc2fa",
  null
  
)

export default component.exports